import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import { AgGridVue } from "ag-grid-vue";
import Vue from "vue";
import moduleDrilling from "../store/moduleDrilling.js";
import UnmappedActionsCellRenderer from "./components/UnmappedActionsCellRenderer.vue"
import UnmappedSideView from "./components/UnmappedSideView.vue";
import service from "./../staging/stagingDailyReportService.js"

export default {
  components: {
    /* eslint-disable vue/no-unused-components */
    AgGridVue,
    UnmappedActionsCellRenderer,
    UnmappedSideView
  },
  data() {
    return {
      isSidebarActive: false,
      sidebarData: {},

      selectedDailyReportId: null,
      importationPopupActive : false,
      selectedProjectId: null, // This might be used when a user assigns a contract to his own project
      unmappedList: [],

      // grid attributes
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false
      },
      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.stagingDailyReportId;
        }
      },
      context: { componentParent: this },
      rowClassRules: {
      },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'stagingDailyReportId',
          width: 250,
          editable: false,
          sortable: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: Vue.extend(UnmappedActionsCellRenderer)
        },
        {
          headerName: this.$t('Drilling.Unmapped.ReportDate'),
          field: "reportDate",
          filter: true,
          width: 165,
          valueFormatter: x => this.$options.filters.toDate(x.value)
        },
        { 
          headerName: this.$t('Drilling.Drills.Name'),
          field: "drillCode",
          filter: true,
          width: 150
        },
        { 
          headerName: this.$t('Drilling.Contracts.Name'),
          field: "contractNumber",
          filter: true,
          width: 165
        },
        { 
          headerName: this.$t('Drilling.Projects.SingleTitle'),
          field: "projectCode",
          filter: true,
          width: 165
        },
        { 
          headerName: this.$t('Drilling.DailyReports.Vendor'),
          field: "vendor",
          filter: true,
          width: 165
        },
        { 
          headerName: this.$t('Drilling.JobEntries.Hours'),
          field: "totalHours",
          filter: true,
          width: 165
        },
        { 
          headerName: this.$t('Drilling.DrillEntries.MetersDrilled'),
          field: "totalMetersDrilled",
          filter: true,
          width: 200
        },
        { 
          headerName: this.$t('Drilling.Holes.Title'),
          field: "holes",
          filter: false,
          width: 165
        }
      ],
      components: {
        UnmappedActionsCellRenderer
      }
    };
  },

  computed: {
    multipleRowsSelected() {
      // For some reason, this doesn't work, at all.
      // If you get this thing to work, I'll buy you a beer.

      // if (!this.gridApi) return false;
      // return this.gridApi.getSelectedRows().length > 1;

      return true;
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.$refs.listCard.refreshcard();
  },
  created() {
    if (!moduleDrilling.isRegistered) {
      this.$store.registerModule("drilling", moduleDrilling);
      moduleDrilling.isRegistered = true;
    }

    this.selectedMainProjectId = Number(this.$store.state.projectId);

  },
  methods: {
    toggleDataSidebar(val = false) {
      this.isSidebarActive = val;
    },

    editData(data) {
      // router.push({ name: 'drilling-staging-edit', params: { stagingDailyReportId: dailyReport.stagingDailyReportId } });
      this.sidebarData = {
        rows: [data]
      };
      this.toggleDataSidebar(true);
    },

    deleteData(id) {
      this.$vs.loading();
      return service.delete(id, this)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("Drilling.DailyReports.DailyReportDeleted"));
        }).finally(() => {
          this.$vs.loading.close();
          this.$refs.listCard.refreshcard();
        });
    },

    batchDelete() {
      const rows = this.gridApi.getSelectedRows();
      if (rows.length === 0) {
        this.$vs.notify({
          color: "danger",
          title: this.$t("Error"),
          text: this.$t("Drilling.Unmapped.NoRowsSelected")
        });
        return;
      }
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: this.$t('Restore'),
        text: this.$t('Drilling.Unmapped.ConfirmDeleteMultiple'),
        accept: () => {
          this.$vs.loading();
          Promise.all(rows.map(row => service.delete(row.stagingDailyReportId, this)))
            .then(() => {
              this.$notifyDeleteSuccess(this.$t("Drilling.Unmapped.DailyReportsDeleted"));
            }).finally(() => {
              this.$vs.loading.close();
              this.$refs.listCard.refreshcard();
            });
        }
      });
    },

    getUnmappedEntries() {
      service.findUnmapped(this.selectedMainProjectId, this)
        .then((response) => {
          this.unmappedList = response.data.model;
        })
        .catch((error) => {
          this.$notifyLoadingError(error.message);
        }).finally(() => {
          this.$refs.listCard.removeRefreshAnimation();
        })
    },

    batchMapping() {
      const rows = this.gridApi.getSelectedRows();
      if (rows.length === 0) {
        this.$vs.notify({
          color: "danger",
          title: this.$t("Error"),
          text: this.$t("Drilling.Unmapped.NoRowsSelected")
        });
        return;
      }

      this.sidebarData = {
        rows
      };
      this.toggleDataSidebar(true);
    },

    onSubmitted() {
      this.toggleDataSidebar();
      this.getUnmappedEntries();
    }
  }
};